import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  Navigate,
} from "react-router-dom";

import LandPage from "./LandPage";
import MapApp from "./OpenLayer";
import Dashboard from "./Dashboard";
import UserManagement from "./UserManagement";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

function LandingPage() {
  const navigate = useNavigate();
  return (
    <LandPage
      onNavigateToMap={() => navigate("/mapview")}
      onNavigateToDashboard={() => navigate("/dashboard")}
      onNavigateToUsers={() => navigate("/users")}
    />
  );
}

function MapPage() {
  const navigate = useNavigate();
  return (
    <MapApp
      onBackToHome={() => navigate("/")}
      onNavigateToDashboard={() => navigate("/dashboard")}
    />
  );
}

function DashboardPage() {
  const navigate = useNavigate();
  return (
    <Dashboard
      onBackToHome={() => navigate("/")}
      onNavigateToMap={() => navigate("/mapview")}
    />
  );
}

function UsersPage() {
  const navigate = useNavigate();
  return <UserManagement onBackToHome={() => navigate("/")} />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter basename="/gisportal">
      <AuthProvider>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route
            path="/mapview"
            element={
              <ProtectedRoute path="/mapview">
                <MapPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute path="/dashboard">
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute path="/users">
                <UsersPage />
              </ProtectedRoute>
            }
          />
          <Route path="/index.html" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
